import { render, staticRenderFns } from "./CarbohydrateOff.vue?vue&type=template&id=74b8301f&scoped=true"
import script from "./CarbohydrateOff.vue?vue&type=script&lang=js"
export * from "./CarbohydrateOff.vue?vue&type=script&lang=js"
import style0 from "./CarbohydrateOff.vue?vue&type=style&index=0&id=74b8301f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b8301f",
  null
  
)

export default component.exports